import { TenantPackageConfig } from '~/tenants/common/registry';
import { McmOrderContext } from '~/tenants/mcm/model/McmOrder';
import McmPhotoConfig from '~/tenants/mcm/performable/photo/McmPhotoConfig';
import McmZillowConfig from '~/tenants/mcm/performable/zillow/McmZillowConfig';
import McmDroneConfig, { McmDroneType } from '~/tenants/mcm/performable/drone/McmDroneConfig';

const McmPackageCrossroadsSilver: TenantPackageConfig<McmOrderContext> = {
  id: 'cr_silver',
  name: 'Crossroads Silver Drone',
  hideSavings: true,
  performables: [
    McmPhotoConfig,
    McmZillowConfig,
    {
      config: McmDroneConfig,
      metadata: {
        type: McmDroneType.PHOTO,
        daytime: true,
      },
    },
  ],
  eligible: ({ buyer, parent }) => Boolean(buyer.metadata.crossroads || parent?.crossroads),
  description: '30-40 Photos, Zillow 2D  Floorplan + Zillow 3D, Drone Stills Only'
};

export default McmPackageCrossroadsSilver;
